import { render, staticRenderFns } from "./jf-ticket-scanner.vue?vue&type=template&id=19a3f6ff&lang=pug&"
import script from "./jf-ticket-scanner.vue?vue&type=script&lang=js&"
export * from "./jf-ticket-scanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports